// extracted by mini-css-extract-plugin
export default {"object-popup":"object-popup_object-popup__cRmKu","object-popup_tip_hidden":"object-popup_object-popup_tip_hidden__TKQca"};